<template>
<div class="factor-source-chart-wrapper">
  <e-chart ref="chart" />
</div>
</template>

<script>
import EChart from '../../../../../components/Charts/ECharts'
export default {
  name: 'FactorSourceChart',
  components: {EChart},
  props: {
    dimensions: {
      required: true,
      type: Array
    },
    seriesMap: {
      required: true,
      type: Object
    }
  },
  methods: {
    renderChart () {
      const {dimensions, seriesMap} = this
      const chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        grid: {
          top: 40,
          right: 30,
          bottom: 20,
          left: 30,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          nameLocation: 'center',
          data: dimensions.map(dimension => dimension.name),
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false
          },
          axisLabel: {
            rotate: 90
          }
        },
        yAxis: [{
          type: 'value',
          name: `%`,
          max: 100,
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            onZero: false
          },
          axisTick: {
            show: true
          }
        }, {
          type: 'value',
          name: '浓度',
          position: 'right',
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            onZero: false
          },
          axisTick: {
            show: true
          }
        }],
        series: [{
          name: '占比',
          type: 'bar',
          barMaxWidth: 30,
          data: seriesMap.percents,
          color: seriesMap.color,
          yAxisIndex: 0
        }, {
          name: '浓度',
          type: 'scatter',
          data: seriesMap.concs,
          yAxisIndex: 1
        }]
      }

      this.$refs.chart.setOpt(chartOpt, true)
    }
  },
  watch: {
    seriesMap () {
      this.renderChart()
    }
  },
  mounted () {
    setTimeout(() => {
      this.renderChart()
    }, 0)
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/FactorSourceChart.vue